import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// 1. Import PostHog
import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react';

// 2. Initialize PostHog
// This will use the keys from your .env file
posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_HOST,
    // This line makes sure it only runs on your live Vercel site
    if: process.env.NODE_ENV === 'production' 
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* 3. Wrap your App in the PostHogProvider */}
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  </React.StrictMode>
);

// Your original reportWebVitals call
reportWebVitals();